Reflect.matchType = function <O extends object, T extends O[keyof O]>(typeObject: O, value: T): value is T {
	return Object.values(typeObject).includes(value);
};

Reflect.typeFlat = function <T>(typeObject: T): T[] {
	return Object.values(typeObject).map(value => value as T);
};

export {};
